const managers = {
    "TOKEN_NOT_PASSED":"Секрет авторизации не передан",
    "TOKEN_NOT_PASSED_DESCRIPTION":"Не можем авторизироваться т.к в запросе отсутствует идентификатор сессии",
};
export default managers;